import { render, staticRenderFns } from "./StatisticsAccessByRecentModel.vue?vue&type=template&id=4679a75f&"
import script from "./StatisticsAccessByRecentModel.vue?vue&type=script&lang=js&"
export * from "./StatisticsAccessByRecentModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports